export const pluralize = (word: string, condition: boolean): string =>
  condition ? `${word}s` : word
